<template>
  <b-modal v-model="isActive" :width="640" scroll="keep" :can-cancel="['escape', 'outside']" @close="close">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          <i class="mr-2 mdi mdi-alert-circle-outline"></i>{{ $t('expiredCompaniesDialog.title') }}
        </p>
      </header>
      <section class="modal-card-body">
        <p class="mb-3">{{ $t('expiredCompaniesDialog.message') }}</p>
        <b-table :data="companies">
          <b-table-column field="name" :label="$t('expiredCompaniesDialog.company')" v-slot="props">
            {{ props.row.name }}
          </b-table-column>
          <b-table-column field="serviceEndDate" :label="$t('expiredCompaniesDialog.endDate')" v-slot="props">
            {{ toDisplayDate(props.row.serviceEndDate) }}
          </b-table-column>
          <b-table-column field="serviceEndReason" :label="$t('expiredCompaniesDialog.reason')" v-slot="props">
            {{ props.row.serviceEndReason ? $t(`expiredCompaniesDialog.reasons.${props.row.serviceEndReason}`) : '' }}
          </b-table-column>
        </b-table>
        <b-notification v-if="!hasActiveCompanies" type="is-danger" :closable="false" class="mt-4">
          {{ $t('expiredCompaniesDialog.allExpired') }}
        </b-notification>
      </section>
      <footer class="modal-card-foot">
        <b-button type="is-info" :label="$t('expiredCompaniesDialog.accept')" @click="close"/>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import CompanyEndpoint from "@/endpoints/core/CompanyEndpoint";
import ExpiredDialogSession from "@/global/session/ExpiredDialogSession";
import {toDisplayDate} from "@/global/company/serviceTerm";

/**
 * Diálogo post-login "Suscripción vencida".
 *
 * Regla de negocio: si el usuario tiene empresas vencidas (propias o por herencia) ve cada empresa causante
 * con su fecha, una vez por sesión. Si ya no le queda ninguna vigente, se le indica contactar a soporte o
 * comercial. Solo informa: no bloquea la navegación.
 */
export default {
  name: "ExpiredCompaniesDialog",
  data: () => ({
    isActive: false,
    companies: [],
    hasActiveCompanies: true,
  }),
  async mounted() {
    if (ExpiredDialogSession.wasShown()) {
      return;
    }
    const summary = await CompanyEndpoint.getExpired();
    if (!summary) {
      // Falló la consulta: no se marca como mostrado para reintentar en el próximo montaje.
      return;
    }
    this.companies = summary.companies || [];
    this.hasActiveCompanies = summary.hasActiveCompanies !== false;
    if (this.companies.length === 0) {
      ExpiredDialogSession.markShown();
      return;
    }
    this.isActive = true;
  },
  methods: {
    toDisplayDate,
    close() {
      ExpiredDialogSession.markShown();
      this.isActive = false;
    },
  },
};
</script>
